// @ts-nocheck 51b1bdf8
import * as actionTypes from './externalLinksActionTypes';

const overrideExternalLinks = (override) => ({
  type: actionTypes.OVERRIDE_EXTERNAL_LINK,
  override,
});

export { overrideExternalLinks };
